import store from "@/store/index"
import Vue from "vue"
import VueRouter from "vue-router"
import Cookies from "js-cookie"

import Intranet from "@/layouts/intranet/Index.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/login",
    component: () => import("@/layouts/intranet_empty/Index.vue"),
    children: [
      {
        path: "",
        name: "login",
        component: () => import("@/views/UserLogin.vue"),
        meta: {
          auth: false,
          title: "Accés d'usuari",
        },
      },
    ],
  },
  {
    path: "/",
    component: Intranet,
    children: [
      {
        path: "",
        component: () => import("@/views/Dashboard.vue"),
        name: "dashboard",
        meta: {
          auth: true,
          title: "Panell de control",
        },
      },
    ],
  },
  {
    path: "/users",
    component: Intranet,
    children: [
      {
        path: "",
        name: "users",
        component: () => import("@/views/crud/UserCrud.vue"),
        meta: {
          auth: true,
          title: "Usuaris",
          fluid: true,
        },
      },
    ],
  },
  {
    path: "/activitats",
    component: Intranet,
    children: [
      {
        path: "",
        name: "exercicis",
        component: () => import("@/views/crud/ActivitatCrud.vue"),
        meta: {
          auth: true,
          title: "Activitats",
          fluid: true,
        },
      },
    ],
  },
  {
    path: "/metodologies",
    component: Intranet,
    children: [
      {
        path: "",
        name: "metodologies",
        component: () => import("@/views/crud/MetodologiaCrud.vue"),
        meta: {
          auth: true,
          title: "Metodologies",
          // fluid: false
        },
      },
    ],
  },
  {
    path: "/planificacions",
    component: Intranet,
    children: [
      {
        path: "",
        name: "planificacions",
        component: () => import("@/views/crud/PlanificacioCrud.vue"),
        meta: {
          auth: true,
          title: "Planificacions",
          // fluid: false
        },
      },
      {
        path: ":id",
        name: "planificador_mesocicles",
        component: () => import("@/views/planificacions/PlanificacioKanban.vue"),
        meta: {
          auth: true,
          title: "Planificació",
          fluid: true,
        },
      },
    ],
  },
  {
    path: "/mesocicles",
    component: Intranet,
    children: [
      {
        path: ":id/sessions",
        name: "planificador_sessions",
        component: () => import("@/views/mesocicles/MesocicleKanban.vue"),
        meta: {
          auth: true,
          title: "Mesocicle",
          fluid: true,
        },
      },
    ],
  },
  {
    path: "/objectius",
    component: Intranet,
    children: [
      {
        path: "",
        name: "objectius",
        component: () => import("@/views/crud/ObjectiuCrud.vue"),
        meta: {
          auth: true,
          title: "Objectius",
          // fluid: false
        },
      },
    ],
  },
  {
    path: "/progressions",
    component: Intranet,
    children: [
      {
        path: "",
        name: "progressions",
        component: () => import("@/views/crud/ProgressioCrud.vue"),
        meta: {
          auth: true,
          title: "Progressions",
          // fluid: false
        },
      },
    ],
  },
  {
    path: "/ambits-especifics",
    component: Intranet,
    children: [
      {
        path: "",
        name: "ambits_especifics",
        component: () => import("@/views/crud/AmbitEspecificCrud.vue"),
        meta: {
          auth: true,
          title: "Àmbits específics",
          // fluid: false
        },
      },
    ],
  },
  {
    path: "/ambits-generals",
    component: Intranet,
    children: [
      {
        path: "",
        name: "ambits_generals",
        component: () => import("@/views/crud/AmbitGeneralCrud.vue"),
        meta: {
          auth: true,
          title: "Àmbits generals",
          // fluid: false
        },
      },
    ],
  },
  {
    path: "/elements-tecnics-tactics",
    component: Intranet,
    children: [
      {
        path: "",
        name: "elements_tecnics_tactics",
        component: () => import("@/views/crud/ElementTecnicTacticCrud.vue"),
        meta: {
          auth: true,
          title: "Elements tècnic-tàctics",
          // fluid: false
        },
      },
    ],
  },
  {
    path: "/materials-usats",
    component: Intranet,
    children: [
      {
        path: "",
        name: "materials_usats",
        component: () => import("@/views/crud/MaterialUsatCrud.vue"),
        meta: {
          auth: true,
          title: "Materials usats",
          // fluid: false
        },
      },
    ],
  },
  {
    path: "/nivells",
    component: Intranet,
    children: [
      {
        path: "",
        name: "nivells",
        component: () => import("@/views/crud/NivellCrud.vue"),
        meta: {
          auth: true,
          title: "Nivells",
          // fluid: false
        },
      },
    ],
  },
  {
    path: "/nombre-participants",
    component: Intranet,
    children: [
      {
        path: "",
        name: "nombre_participants",
        component: () => import("@/views/crud/NombreParticipantCrud.vue"),
        meta: {
          auth: true,
          title: "Nombre de participants",
          // fluid: false
        },
      },
    ],
  },
  {
    path: "/qualitats-fisiques-basiques",
    component: Intranet,
    children: [
      {
        path: "",
        name: "qualitats_fisiques_basiques",
        component: () => import("@/views/crud/QualitatFisicaBasicaCrud.vue"),
        meta: {
          auth: true,
          title: "Qualitats físiques-bàsiques",
          // fluid: false
        },
      },
    ],
  },
  {
    path: "/qualitats-psicomotrius",
    component: Intranet,
    children: [
      {
        path: "",
        name: "qualitats_psicomotrius",
        component: () => import("@/views/crud/QualitatPsicomotriuCrud.vue"),
        meta: {
          auth: true,
          title: "Qualitats psicomotrius",
          // fluid: false
        },
      },
    ],
  },
  {
    path: "/tipus-activitats",
    component: Intranet,
    children: [
      {
        path: "",
        name: "tipus_activitats",
        component: () => import("@/views/crud/TipusExerciciCrud.vue"),
        meta: {
          auth: true,
          title: "Tipus d'activitats",
        },
      },
    ],
  },
  {
    path: "*",
    component: () => import("@/views/errors/404.vue"),
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  let authRequired = to.matched.some(record => record.meta.auth)
  const loggedIn = Cookies.get("auth_token")
  if (authRequired === true && !loggedIn) {
    store.state.login_redirect = to.fullPath
    next("/login")
  } else if (authRequired === false && loggedIn) {
    next("/")
  } else {
    next()
  }
})

export default router
